module.exports = __webpack_public_path__ + "img/smartphone-white.a9ce73b7.png";